import { render } from "./ViewNotice.vue?vue&type=template&id=3fde86a4&scoped=true"
import script from "./ViewNotice.vue?vue&type=script&lang=js"
export * from "./ViewNotice.vue?vue&type=script&lang=js"

import "./ViewNotice.vue?vue&type=style&index=0&id=3fde86a4&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fde86a4"]])

export default __exports__